import { COUNTRY_CODES, countryName } from '@till-erp/platform/countries';
import { isoCurrencyCodes } from '@till-erp/platform/currencies';
import type { ComboOption } from './combobox.ts';

export { exactMatch, offerCreate } from './combobox.ts';

/**
 * Feste Optionen der Auswahl mit Suche (Ticket 1.257): Land und Währung. Gespeichert wird das ISO-Kürzel, angezeigt der
 * deutsche Name. Häufige Werte stehen oben über dem feinen Strich (DESIGN „Auswahl mit Suche“).
 */

/** Oben in der Land-Auswahl (DESIGN: Deutschland, Österreich, Schweiz). */
export const FREQUENT_COUNTRIES: readonly string[] = ['DE', 'AT', 'CH'];

/** Oben in der Währungs-Auswahl (DESIGN: EUR, CHF, USD, GBP). */
export const FREQUENT_CURRENCIES: readonly string[] = ['EUR', 'CHF', 'USD', 'GBP'];

/** Anzeige eines Lands: „Österreich · AT“. */
export function countryLabel(code: string): string {
  const name = countryName(code);
  return name === code ? code : `${name} · ${code}`;
}

let countries: ComboOption[] | null = null;

/** Alle Länder (ISO 3166-1 alpha-2, dazu XK) alphabetisch nach deutschem Namen. */
export function countryOptions(): readonly ComboOption[] {
  countries ??= COUNTRY_CODES.map((code) => ({ value: code, label: countryLabel(code), keys: [code, countryName(code)] })).sort((a, b) =>
    a.label.localeCompare(b.label, 'de'),
  );
  return countries;
}

/** Deutscher Name einer Währung („CHF“ → „Schweizer Franken“); ohne Namen das Kürzel selbst. */
export function currencyName(code: string): string {
  try {
    return new Intl.DisplayNames(['de'], { type: 'currency', fallback: 'code' }).of(code) ?? code;
  } catch {
    return code;
  }
}

/** Anzeige einer Währung: „CHF – Schweizer Franken“ (ohne Namen nur das Kürzel). */
export function currencyLabel(code: string): string {
  const name = currencyName(code);
  return name === code ? code : `${code} – ${name}`;
}

let currencies: ComboOption[] | null = null;

/** Alle Währungen nach ISO 4217, alphabetisch nach Kürzel. */
export function currencyOptions(): readonly ComboOption[] {
  currencies ??= isoCurrencyCodes.map((code) => ({ value: code, label: currencyLabel(code), keys: [code] }));
  return currencies;
}
